import React from 'react';
import PropTypes from 'prop-types';
import PageAncestor from 'core/common/page/pageAncestor';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {Link} from 'react-router';
import {addTenantToQuery} from "core/common/utils/utils";
import {loc} from "core/common/config/locales";


@observer
export default class ReferenceList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Reference Tables`;
  static icon = 'server';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ReferenceList#fetchData %O", routerParams);
    // return Promise.all([gridService.fetchGrids(gridLocation), jobService.readAvailableJobs()])
    //   .then(([gridLocationMap, availableJobs]: [ObservableMap<GridLocation>, {[key: string]: string[]}]) => {
    //     jobService.availableJobs = availableJobs;
    //     return gridService.getOrCreateGrid(gridLocation);
    //})
  }

  static contextTypes = {
    router: PropTypes.func.isRequired
  };




  render() {
    let {params, query} = this.props;


    return (
      <main className="main-content">
        <table className="zz-simple-table" style={{margin: 20}}>
          <tbody>
            <tr>
              <td>
                <Link to="referenceDetail" params={{id: "Country"}}  query={addTenantToQuery()}>Countries</Link>
              </td>
            </tr>
          </tbody>
        </table>
      </main>
    );
  }

}




// WEBPACK FOOTER //
// ./src/administration/referenceTables/referenceList.tsx